<template>
  <div v-if="!schemaModel.$disabled" class="row align-items-end">
    <w-datepicker class="form-group col-6" :model="$schema.date" :title="dateTitle" @input="handleDateInput" />

    <w-input
      class="form-group col-6"
      type="time"
      step="1"
      :model="$schema.time"
      :title="timeTitle"
      @input="handleInput"
    />
  </div>
</template>

<script>
import { schemaMixin } from '@witkac/jschema';
import moment from 'moment';

import { dateTimePickerSchema } from '../schemas/dateTimePicker.schema';
import WDatepicker from './datepicker.vue';
import WInput from './input.vue';

// @vuese
// Komponent do ustawiania daty i godziny
// @group Forms
export default {
  components: { WInput, WDatepicker },

  mixins: [schemaMixin],

  schema: dateTimePickerSchema,

  props: {
    // Model daty z godziną
    schemaModel: { type: Object, required: true },

    // Tytuł pola na datę
    dateTitle: { type: String, required: false },

    // Tytuł pola na czas
    timeTitle: { type: String, required: false }
  },

  data() {
    return { localChange: false, model: {} };
  },

  watch: {
    'schemaModel.$schema.fieldRequired': {
      handler(newValue) {
        this.setIsRequired(newValue);
      }
    },
    'schemaModel.$disabled': {
      handler(newValue) {
        this.setIsDisabled(newValue);
      }
    },
    'schemaModel.$dirty': {
      handler(newValue) {
        if (newValue) {
          this.$schema.$validateAll();
          this.$schema.$checkAll();
        }
      }
    },
    'schemaModel.$model': {
      immediate: true,
      handler(newValue, oldValue) {
        if (this.localChange) {
          this.localChange = false;
          return;
        }

        if (!newValue && !oldValue) {
          return;
        }

        if (!newValue) {
          this.clear();
          return;
        }

        const momentDate = moment(newValue);
        if (!momentDate || !momentDate.isValid()) {
          this.clear();
          this.schemaModel.$setData(null);
          return;
        }

        const date = momentDate.format('YYYY-MM-DD');
        const time = momentDate.format('HH:mm:ss');

        this.$schema.date.$setData(date);
        this.$schema.time.$setData(time);
      }
    }
  },

  mounted() {
    this.setIsRequired(this.schemaModel.$schema.fieldRequired);
    this.setIsDisabled(this.schemaModel.$disabled);
  },

  methods: {
    // Obsługa wybrania daty
    handleDateInput() {
      if (this.$schema.date.$getData() && !this.$schema.time.$getData()) {
        this.$schema.time.$setData('00:00:00');
      }
      this.handleInput();
    },

    // Obsługa wpisania/wybrania czegoś
    handleInput() {
      this.$nextTick(() => {
        const value = this.$schema.dateTime.$getData() || null;
        this.localChange = true;
        this.schemaModel.$setData(value);
        this.$emit('input', value);
      });
    },

    // @vuese
    // Ustawia wymagalność pól
    setIsRequired(isRequired) {
      this.$schema.isRequired.$setData(isRequired);
    },

    // @vuese
    // Ustawia wyłączenie pól
    setIsDisabled(isDisabled) {
      this.$schema.isDisabled.$setData(isDisabled);
    },

    // @vuese
    // Czyści pola
    clear() {
      this.$schema.date.$setDefault();
      this.$schema.time.$setDefault();
    }
  }
};
</script>
